import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectAlert = (state: AppState) => state.alert;

export const getAlerts = () => createSelector(selectAlert, (state) => state.alerts);
export const getAlertNotifications = () => createSelector(selectAlert, (state) => state.alertNotifications);
export const getAlertNotificationsHr = () => createSelector(selectAlert, (state) => state.hrAlertNotifications);
export const getAlertNotificationsRr = () => createSelector(selectAlert, (state) => state.rrAlertNotifications);

export const getAlertNotificationsTotalHr = () =>
  createSelector(selectAlert, (state) => state.hrAlertNotificationsTotal);

export const getAlertNotificationsTotal = () => createSelector(selectAlert, (state) => state.alertNotificationsTotal);

export const getAlertNotificationsTotalRr = () =>
  createSelector(selectAlert, (state) => state.rrAlertNotificationsTotal);
export const getHrFilter = () => createSelector(selectAlert, (state) => state.hrFilter);
export const getRrFilter = () => createSelector(selectAlert, (state) => state.rrFilter);
export const getFilter = () => createSelector(selectAlert, (state) => state.filter);
